export default __webpack_public_path__ + "static/media/J730MANC4.c4b4f10c.pdf";